/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {DataViewAccessDTO} from '../model/dataViewAccessDTO';
import {DataViewDetailDto} from '../model/dataViewDetailDto';
import {DataViewDto} from '../model/dataViewDto';
import {DataViewLiteDto} from '../model/dataViewLiteDto';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {DataViewHtmlDto} from "../model/dataViewHtmlDto";


@Injectable()
export class ConfiguratorDataViewService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une nouvelle DataView
     * Cette requête permet de créer une nouvelle DataView&lt;br&gt;Si la DataView est créée avec succès, on aura le code HTTP 201 (Created) avec en corps de réponse la DataView créée.&lt;br&gt;Si la DataView n&#39;est pas créée, on aura le code HTTP 400 (Bad Request) avec en corps de réponse un message d&#39;erreur.
     * @param xDataStoreID X-DataStoreID
     * @param dataView dataView
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDataViewUsingPOST(xDataStoreID: string, dataView: DataViewDto, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public createDataViewUsingPOST(xDataStoreID: string, dataView: DataViewDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public createDataViewUsingPOST(xDataStoreID: string, dataView: DataViewDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public createDataViewUsingPOST(xDataStoreID: string, dataView: DataViewDto, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createDataViewUsingPOST.');
        }

        if (dataView === null || dataView === undefined) {
            throw new Error('Required parameter dataView was null or undefined when calling createDataViewUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DataViewDto>(`${this.basePath}/api/data-views`,
            dataView,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer une DataView
     * Cette requête prend comme paramètre l&#39;identifiant de la DataView à supprimer.&lt;br&gt;Après la suppression, la requête renvoie le code de succès 204 (NO_CONTENT).&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; X_DATASTORE_ID est le code du data store.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDataViewUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteDataViewUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteDataViewUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteDataViewUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteDataViewUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteDataViewUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/data-views/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les DataViews
     * Cette requête prend comme header le code du datastore et renvoie la liste de toutes les DataViews qui lui sont associées.&lt;br&gt;Comme exemple de dataView, on peut avoir : \&quot;Contact pour les commandes de type Vol\&quot;, \&quot;Achats\&quot; ou \&quot;Commande vol\&quot;.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllDataViewsUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DataViewLiteDto>>;
    public getAllDataViewsUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DataViewLiteDto>>>;
    public getAllDataViewsUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DataViewLiteDto>>>;
    public getAllDataViewsUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllDataViewsUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<DataViewLiteDto>>(`${this.basePath}/api/data-views`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les DataViews avec l'accès pour un affilié
     *
     * @param xDataStoreID X-DataStoreID
     * @param partnerId partnerId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataViewAccess(xDataStoreID: string, partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<DataViewAccessDTO>;
    public getDataViewAccess(xDataStoreID: string, partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewAccessDTO>>;
    public getDataViewAccess(xDataStoreID: string, partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewAccessDTO>>;
    public getDataViewAccess(xDataStoreID: string, partnerId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDataViewAccess.');
        }

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling getDataViewAccess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<DataViewAccessDTO>('get',`${this.basePath}/api/data-views/access`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour l'accès aux DataViews pour un affilié
     *
     * @param body
     * @param xDataStoreID X-DataStoreID
     * @param partnerId partnerId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDataViewAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<DataViewAccessDTO>;
    public updateDataViewAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewAccessDTO>>;
    public updateDataViewAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewAccessDTO>>;
    public updateDataViewAccess(body: Array<string>, xDataStoreID: string, partnerId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateDataViewAccess.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateDataViewAccess.');
        }

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling updateDataViewAccess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DataViewAccessDTO>('patch',`${this.basePath}/api/data-views/access`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDataViewDetail
     *
     * @param xDataStoreID X-DataStoreID
     * @param codeTable codeTable
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataViewDetailUsingGET(xDataStoreID: string, codeTable: string, observe?: 'body', reportProgress?: boolean): Observable<DataViewDetailDto>;
    public getDataViewDetailUsingGET(xDataStoreID: string, codeTable: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDetailDto>>;
    public getDataViewDetailUsingGET(xDataStoreID: string, codeTable: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDetailDto>>;
    public getDataViewDetailUsingGET(xDataStoreID: string, codeTable: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDataViewDetailUsingGET.');
        }

        if (codeTable === null || codeTable === undefined) {
            throw new Error('Required parameter codeTable was null or undefined when calling getDataViewDetailUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codeTable !== undefined && codeTable !== null) {
            queryParameters = queryParameters.set('codeTable', <any> codeTable);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<DataViewDetailDto>(`${this.basePath}/api/data-views-detail/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une dataView par son code
     * Cette requête prend comme variable PATH le code du datastore et renvoie la DataView dont l&#39;identifiant est passé en paramètre.&lt;br&gt;Noter que l&#39;identifiant de la DataView &lt;b&gt;id&lt;/b&gt; passé en paramètre peut être son vrai identifiant si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;false&lt;/b&gt;,ou son code si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;true&lt;/b&gt;.&lt;br&gt;Si la DataView est trouvée, on aura le code HTTP 200 (OK) avec en corps de réponse la DataView.&lt;br&gt;Si la DataView n&#39;est pas trouvée, on aura le code HTTP 404 (Not Found) avec en corps de réponse un message d&#39;erreur.&lt;br&gt;Cette requête renvoie une DataView et pas un DTO.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param isCode isCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataViewPramUsingGET(xDataStoreID: string, id: string, isCode?: boolean, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public getDataViewPramUsingGET(xDataStoreID: string, id: string, isCode?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public getDataViewPramUsingGET(xDataStoreID: string, id: string, isCode?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public getDataViewPramUsingGET(xDataStoreID: string, id: string, isCode?: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDataViewPramUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDataViewPramUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isCode !== undefined && isCode !== null) {
            queryParameters = queryParameters.set('isCode', <any> isCode);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<DataViewDto>(`${this.basePath}/api/data-views/${encodeURIComponent(String(id))}/param`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une DataView par son identifiant
     * Cette requête prend comme variable PATH le code du datastore et renvoie la DataView dont l&#39;identifiant est passé en paramètre.&lt;br&gt;Noter que l&#39;identifiant de la DataView &lt;b&gt;id&lt;/b&gt; passé en paramètre peut être son vrai identifiant si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;false&lt;/b&gt;,ou son code si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;true&lt;/b&gt;.&lt;br&gt;Si la DataView est trouvée, on aura le code HTTP 200 (OK) avec en corps de réponse la DataView.&lt;br&gt;Si la DataView n&#39;est pas trouvée, on aura le code HTTP 404 (Not Found) avec en corps de réponse un message d&#39;erreur.&lt;br&gt;Cette requête renvoie un DTO.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param isCode isCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataViewUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, isCode?: boolean, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public getDataViewUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, isCode?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public getDataViewUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, isCode?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public getDataViewUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, isCode?: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getDataViewUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDataViewUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isCode !== undefined && isCode !== null) {
            queryParameters = queryParameters.set('isCode', <any>isCode);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }
        
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DataViewDto>(`${this.basePath}/api/data-views/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une DataView
     * Cette requête permet de mettre à jour une DataView&lt;br&gt;Si la DataView est mise à jour avec succès, on aura le code HTTP 200 (OK) avec en corps de réponse la DataView mise à jour.&lt;br&gt;Si la DataView n&#39;est pas mise à jour, on aura le code HTTP 400 (Bad Request) avec en corps de réponse un message d&#39;erreur.&lt;br&gt;Si la DataView n&#39;a pas pu être mise à jour, on aura le code HTTP 500 (Internal Server Error) avec en corps de réponse un message d&#39;erreur.
     * @param xDataStoreID X-DataStoreID
     * @param dataView dataView
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDataViewUsingPUT(xDataStoreID: string, dataView: DataViewDto, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public updateDataViewUsingPUT(xDataStoreID: string, dataView: DataViewDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public updateDataViewUsingPUT(xDataStoreID: string, dataView: DataViewDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public updateDataViewUsingPUT(xDataStoreID: string, dataView: DataViewDto, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateDataViewUsingPUT.');
        }

        if (dataView === null || dataView === undefined) {
            throw new Error('Required parameter dataView was null or undefined when calling updateDataViewUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<DataViewDto>(`${this.basePath}/api/data-views`,
            dataView,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * Mettre à jour le HTML du DataView
     * Cette requête permet de mettre à jour le HTML du DataView
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDataViewHtml(body: DataViewHtmlDto, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public updateDataViewHtml(body: DataViewHtmlDto, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public updateDataViewHtml(body: DataViewHtmlDto, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public updateDataViewHtml(body: DataViewHtmlDto, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateDataViewHtml.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateDataViewHtml.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DataViewDto>('put',`${this.basePath}/api/data-views/html`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter une vue au format JSON
     * Cette requête permet d'exporter une vue au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportDataViewJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportDataViewJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportDataViewJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportDataViewJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportDataViewJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportDataViewJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/data-views/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs vues au format ZIP
     * Cette requête permet d'exporter plusieurs vues dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportDataViewsZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportDataViewsZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportDataViewsZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportDataViewsZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportDataViewsZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportDataViewsZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/data-views/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer une vue depuis JSON
     * Cette requête permet d'importer une vue depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDataViewJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<DataViewDto>;
    public importDataViewJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataViewDto>>;
    public importDataViewJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataViewDto>>;
    public importDataViewJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importDataViewJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importDataViewJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<DataViewDto>('post',`${this.basePath}/api/data-views/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs vues depuis ZIP
     * Cette requête permet d'importer plusieurs vues depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDataViewsZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<DataViewDto>>;
    public importDataViewsZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DataViewDto>>>;
    public importDataViewsZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DataViewDto>>>;
    public importDataViewsZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importDataViewsZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importDataViewsZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<DataViewDto>>('post',`${this.basePath}/api/data-views/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
